export default __webpack_public_path__ + "static/media/dummyImg.6b5e1287.png";